/* eslint-disable */
// @ts-nocheck
import * as R from 'ramda';
import B from 'bluebird';
import debugLib from 'debug';

import dash_api from '../support/dash_api';
import server from '../support/server';

import { ReduxAsyncAction } from '../support/utils';

import { createDismissFilter, getDismissPeriodFromFilter } from '../screens/ScreenJourneys/utils/journeyHelpers';

import AppsStore from '../stores/AppsStore_LEGACY';
import { sortRows } from '../components/micro-frontends/journeys/frontendPaginate';

const debug = debugLib('JourneyActions');

function findRuleById(rule_list, rule_id) {
  return R.find((rule) => rule.id === rule_id, rule_list);
}

function findNextCopyName(rule_list, previous_name) {
  // DASH-3048
  if (!previous_name) {
    return '';
  }

  // two cases:
  //   1. previous_name is a copy
  //   2. previous_name is an original
  var baseName, largestCopyValue, match, re;

  match = /^([^]+) \((\d)\)$/.exec(previous_name);
  if (match) {
    largestCopyValue = parseInt(match[2], 10);
    baseName = match[1];
  } else {
    largestCopyValue = 0;
    baseName = previous_name;
  }

  re = new RegExp(`^${baseName} \\((\\d)\\)$`);

  // now find the largest value:
  largestCopyValue = R.reduce(
    (value, rule) => {
      match = re.exec(rule.title);
      if (!match) {
        return value;
      }

      var ruleValue = parseInt(match[1], 10);
      if (ruleValue < value) {
        return value;
      }

      return ruleValue;
    },
    largestCopyValue,
    rule_list
  );

  return `${baseName} (${largestCopyValue + 1})`;
}

function getViewsForRule(rule, views) {
  return R.filter((view) => {
    return R.contains(
      view.id,
      R.map((bv) => bv.branch_view_id, rule.branch_views)
    );
  }, views);
}

const getHighestPriority = R.reduce((acc, curr) => {
  if (curr.status === 'ARCHIVED') {
    return acc;
  }
  if (curr.priority > acc) {
    return curr.priority;
  }
  return acc;
}, 0);

export const APP_LOADED = 'JOURNEYS_APP_LOADED';
export function fetchApp() {
  return {
    type: APP_LOADED,
    app: AppsStore.getApp(),
  };
}

const FetchAppStats = new ReduxAsyncAction('JOURNEYS_FETCH_APP_STATS');
FetchAppStats.registerRequest(() => {
  return dash_api.post('/v1/sdk/get-status').then(R.prop('data'));
});
export const FETCH_APP_STATS = FetchAppStats.constants;
export const fetchAppStats = FetchAppStats.request;

const FetchRules = new ReduxAsyncAction('JOURNEYS_FETCH_RULES');
FetchRules.registerRequest((prioritize) => {
  return server('audience rule list load').then(
    (res) => {
      if (prioritize) {
        const clonedRules = Object.assign([], res);
        return sortRows(clonedRules, 'priority');
      } else {
        return res;
      }
    },
    (err) => {
      throw err;
    }
  );
});
export const FETCH_RULES = FetchRules.constants;
export const fetchRules = FetchRules.request;

export const ALL_VIEWS_DICTIONARY = 'JOURNEYS_ALL_VIEWS_DICTIONARY';
export function allViewsDictionary(branch_views = []) {
  return {
    type: ALL_VIEWS_DICTIONARY,
    payload: { branch_views },
  };
}

const FetchViews = new ReduxAsyncAction('JOURNEYS_FETCH_VIEWS');
FetchViews.registerRequest(() => {
  return server('branch view list load').then((view_list) => {
    FetchViews.dispatch(allViewsDictionary(view_list));
    return view_list;
  });
});
export const FETCH_VIEWS = FetchViews.constants;
export const fetchViews = FetchViews.request;

const SaveRule = new ReduxAsyncAction('JOURNEYS_SAVE_RULE');
SaveRule.registerRequest((id, data, rules) => {
  id = id === 'new' ? null : id;

  var priority = data.priority;

  if (!priority && Array.isArray(rules)) {
    // if priority is 0 or undefined, calculate the highest pri
    priority = getHighestPriority(rules) + 1;
  }

  const rule_data = R.assoc('priority', priority, data);
  return server('audience rule save', {
    rule_id: id,
    rule_data,
  });
});
export const SAVE_RULE = SaveRule.constants;
export const saveRule = SaveRule.request;

export function updateRule(rule, key, value) {
  return function (dispatch) {
    const id = rule.id === 'new' ? null : rule.id;

    const newRule = R.assoc(key, value, rule);

    dispatch(SaveRule.request(id, newRule)).then(() => {
      fetchRules;
    });
  };
}

const SaveView = new ReduxAsyncAction('JOURNEYS_SAVE_VIEW');
SaveView.registerRequest((id, view) => {
  debug(SaveView.constants.response, { id, view });

  const view_data = R.clone(view);
  // Remove any data fields that are null OR that we don't want to save
  const innerData = view_data && view_data.data;
  if (innerData && typeof innerData === 'string') {
    let parsed;
    try {
      parsed = JSON.parse(innerData);
    } catch (e) {
      parsed = {};
    }
    Object.keys(parsed).forEach((field) => {
      // JOUR-1876: dismissPeriod is now saved in the rule query, not on the view
      if (parsed[field] === null || field === 'dismissPeriod') {
        delete parsed[field];
      }
    });
    view_data.data = JSON.stringify(parsed);
  }

  return server('branch view save', {
    view_id: id,
    view_data: view_data,
  });
});
export const SAVE_VIEW = SaveView.constants;
export const saveView = SaveView.request;

const DeleteRule = new ReduxAsyncAction('JOURNEYS_DELETE_RULE');
DeleteRule.registerRequest((id, title) => {
  return server('audience rule delete', {
    rule_id: id,
    title,
  }).then(() => id);
});
export const DELETE_RULE = DeleteRule.constants;
export const deleteRule = DeleteRule.request;

const DeleteView = new ReduxAsyncAction('JOURNEYS_DELETE_VIEW');
DeleteView.registerRequest((id, title) => {
  return server('branch view delete', {
    view_id: id,
    title,
  }).then(() => id);
});
export const DELETE_VIEW = DeleteView.constants;
export const deleteView = DeleteView.request;

export function updateView(view_id, view, view_index, editing_rule_id) {
  return function (dispatch) {
    return dispatch(saveView(view_id, view)).then((branch_view) => {
      dispatch({
        type: 'BRANCH_VIEW_LOADED',
        branch_view,
      });

      if (editing_rule_id) {
        dispatch({
          type: 'SET_BRANCH_VIEW_FOR_RULE',
          rule_id: editing_rule_id,
          view_index: view_index,
          view_id: branch_view.id,
        });
      }
      return branch_view.id;
    });
  };
}

export function deleteRuleAndViews(id, rules, views, title) {
  return function (dispatch) {
    return dispatch(deleteRule(id, title))
      .then(() => {
        const rule = findRuleById(rules, id);
        const viewsToDelete = getViewsForRule(rule, views);

        const promises = viewsToDelete.map((view) => {
          return dispatch(deleteView(view.id, view.title));
        });

        return B.all(promises);
      })
      .then(() => {
        dispatch(fetchRules());
        dispatch(fetchViews());
        return;
      });
  };
}

const sortViewsBy = (key) => {
  return (a, b) => {
    if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
      return 0;
    } else if (a[key] < b[key]) {
      return -1;
    } else if (a[key] > b[key]) {
      return 1;
    }
    return 0;
  };
};

export function cloneRule(id, rules, views) {
  return function clone(dispatch) {
    const rule = findRuleById(rules, id);
    const sortedRuleBranchViews = R.sort(sortViewsBy('branch_view_id'), rule.branch_views);

    if (!rule) {
      return;
    }

    const viewsToBeCloned = R.sort(
      sortViewsBy('id'),
      R.filter((view) => {
        return R.contains(
          view.id,
          R.map((bv) => bv.branch_view_id, rule.branch_views)
        );
      }, views)
    );

    if (viewsToBeCloned.length === 0) {
      dispatch(
        saveView(
          'new',
          R.merge(rule, {
            status: 'DRAFT',
            title: findNextCopyName(rules, rule.title),
            campaign: findNextCopyName(rules, rule.campaign),
            priority: null,
          }),
          rules
        )
      );
      return;
    }

    // if there are views associated, we want to make sure they
    // all get cloned properly before saving the rule
    const promises = R.map((view) => {
      return dispatch(saveView(null, view));
    }, viewsToBeCloned);

    B.all(promises)
      .then((clonedList) => {
        const cloneIdPairings = sortedRuleBranchViews.map((view, i) => ({
          preCloneId: view.branch_view_id,
          postCloneId: R.path([i, 'id'], clonedList),
        }));
        // reassociate the cloned views with the rule before saving
        const newBranchViews = sortedRuleBranchViews.map((view, i) => {
          const clonedId = R.path([i, 'id'], clonedList);
          return R.assoc('branch_view_id', clonedId, view);
        });

        return { cloneIdPairings, newBranchViews };
      })
      .then(({ cloneIdPairings, newBranchViews }) => {
        // JOUR-1876: dismissPeriod is now saved in the rule query, not on the view
        cloneIdPairings.forEach((idPair) => {
          const preClonePeriod = getDismissPeriodFromFilter(idPair.preCloneId, rule);
          const preCloneFilter = createDismissFilter(preClonePeriod, idPair.preCloneId);
          const postCloneFilter = createDismissFilter(preClonePeriod, idPair.postCloneId);

          // 1. Delete the pre-cloned view from the query
          rule.builder.findAndDeleteFilter(preCloneFilter);
          // 2. Add the cloned view to the query
          rule.builder.findAndUpdateFilter(postCloneFilter);
          rule.query = rule.builder.getQuery();
        });
        // save the new rule into draft mode with incremented name and cloned views
        return dispatch(
          saveRule(
            'new',
            R.merge(rule, {
              // eslint-disable-line no-use-before-define
              status: 'DRAFT',
              title: findNextCopyName(rules, rule.title),
              campaign: findNextCopyName(rules, rule.campaign),
              branch_views: newBranchViews,
              priority: null,
            }),
            rules
          )
        );
      })
      .then(() => {
        dispatch(fetchRules());
        dispatch(fetchViews());
        return;
      })
      .catch((err) => {
        dispatch({ type: 'JOURNEY_CLONE_RULE_ERROR', data: err });
      });
  };
}

export const UPDATE_SCRATCHPAD_RULE = 'JOURNEYS_UPDATE_SCRATCHPAD_RULE';
export function updateScratchpadRule(key, value) {
  return {
    type: UPDATE_SCRATCHPAD_RULE,
    data: { key, value },
  };
}

export const UPDATE_SCRATCHPAD_VIEW = 'JOURNEYS_UPDATE_SCRATCHPAD_VIEW';
export function updateScratchpadView(key, value) {
  return {
    type: UPDATE_SCRATCHPAD_VIEW,
    data: { key, value },
  };
}

export const LOAD_AUDIENCE_RULE = 'JOURNEYS_LOAD_AUDIENCE_RULE';
export function loadAudienceRule(id, audience_rule) {
  return {
    type: LOAD_AUDIENCE_RULE,
    scratchpad_rule: id ? false : true,
    audience_rule: audience_rule,
  };
}

export const SELECT_RULE_FOR_EDIT = 'JOURNEYS_SELECT_RULE_FOR_EDIT';
export function selectRuleForEdit(rule_id) {
  return {
    type: SELECT_RULE_FOR_EDIT,
    data: { rule_id },
  };
}

export const CLEAR_RULE_FOR_EDIT = 'JOURNEYS_CLEAR_RULE_FOR_EDIT';
export function clearRuleForEdit() {
  return {
    type: CLEAR_RULE_FOR_EDIT,
  };
}

export const SELECT_VIEW_FOR_EDIT = 'JOURNEYS_SELECT_VIEW_FOR_EDIT';
export function selectViewForEdit(view_id) {
  return {
    type: SELECT_VIEW_FOR_EDIT,
    data: { view_id },
  };
}

export const APP_ID_CHANGE = 'JOURNEYS_APP_ID_CHANGE';
export function appIdChange(user_id) {
  return {
    type: APP_ID_CHANGE,
    data: { user_id },
  };
}

export const ADD_VIEW_FOR_RULE = 'JOURNEYS_ADD_VIEW_FOR_RULE';
export function addViewForRule(rule_id) {
  return {
    type: ADD_VIEW_FOR_RULE,
    data: { rule_id },
  };
}

export const REMOVE_VIEW_FOR_RULE = 'JOURNEYS_REMOVE_VIEW_FOR_RULE';
export function removeViewForRule(rule_id, view_index) {
  return {
    type: REMOVE_VIEW_FOR_RULE,
    data: { rule_id, view_index },
  };
}

export const SET_VIEW_FREQUENCY = 'JOURNEYS_SET_VIEW_FREQUENCY';
export function setViewFrequency(rule_id, view_index, freq) {
  return {
    type: SET_VIEW_FREQUENCY,
    data: { rule_id, view_index, freq },
  };
}

export const PRIORITY_SORT = 'JOURNEYS_PRIORITY_SORT';
export function prioritySort() {
  return {
    type: PRIORITY_SORT,
  };
}

const SaveReorderedRules = new ReduxAsyncAction('JOURNEYS_SAVE_REORDERED_RULES');
SaveReorderedRules.registerRequest((rules) => {
  const promises = [];

  R.addIndex(R.forEach)((rule, i) => {
    if (rule.status === 'ARCHIVED') {
      return;
    }
    if (i !== rule.priority - 1) {
      rule.priority = i + 1;

      promises.push(
        server('audience rule save', {
          rule_id: rule.id,
          rule_data: rule,
        })
      );
    }
  }, rules);

  return B.all(promises);
});
SaveReorderedRules.showProgressBar();
export const SAVE_REORDERED_RULES = SaveReorderedRules.constants;
export const saveReorderedRules = SaveReorderedRules.request;

const SaveReorderPriorityFromPopover = new ReduxAsyncAction('JOURNEYS_SAVE_REORDERED_PRIORITY_POPOVER');
SaveReorderPriorityFromPopover.registerRequest((ruleId: string, priority: number, prioritize: boolean) => {
  return server('audience rule priority save', {
    ruleId,
    priority,
  }).then((res) => {
    if (prioritize) {
      return SaveReorderPriorityFromPopover.dispatch(fetchRules(prioritize));
    } else {
      return SaveReorderPriorityFromPopover.dispatch(fetchRules());
    }
  });
});
export const saveReorderPriorityFromPopover = SaveReorderPriorityFromPopover.request;

export const REORDER_TABLE = 'JOURNEYS_REORDER_TABLE';
export function reorderTable(fromId, toId) {
  return {
    type: REORDER_TABLE,
    data: { fromId, toId },
  };
}

export const GET_VIEWS_AVAILABLE_FOR_PLATFORM = 'JOURNEYS_GET_VIEWS_AVAILABLE_FOR_PLATFORM';
export function getViewsAvailableForPlatform(templateTypeOptions, platform) {
  return {
    type: GET_VIEWS_AVAILABLE_FOR_PLATFORM,
    payload: { templateTypeOptions, platform },
  };
}

export const GET_LANGUAGE_TABLE = 'JOURNEYS_GET_LANGUAGE_TABLE';
export function getLanguageTable() {
  return function getInfo(dispatch) {
    return server('string table load').then((data) => {
      const tables = R.values(data);

      dispatch({
        type: GET_LANGUAGE_TABLE,
        data: tables,
      });
    });
  };
}

export const SAVE_LANGUAGE_TABLE = 'JOURNEYS_SAVE_LANGUAGE_TABLE';
export function saveLanguageTable(table) {
  return function saveInfo(dispatch) {
    return server('string table save', {
      table: table,
    }).then((data) => {
      dispatch({
        type: SAVE_LANGUAGE_TABLE,
        data: data,
      });
    });
  };
}

/**
 * Store the journey Id so that a warning modal is not
 * shown for trying to save the journey until page is refreshed
 * @param  {string} journeyId
 * @return {Object} redux action
 */
export const JOURNEY_DISMISS_SAVE_WARNING = 'JOURNEY_DISMISS_SAVE_WARNING';
export function dismissSaveWarningForJourney(journeyId) {
  return {
    type: JOURNEY_DISMISS_SAVE_WARNING,
    data: journeyId,
  };
}

const SearchGeoRegions = new ReduxAsyncAction('JOURNEYS_SEARCH_GEO_REGIONS');
SearchGeoRegions.registerRequest((query) => {
  return dash_api.get(`/v1/audience-rule/regions/search?q=${encodeURIComponent(query)}`).then(R.prop('data'));
});
export const SEARCH_GEO_REGIONS = SearchGeoRegions.constants;
export const searchGeoRegions = SearchGeoRegions.request;

const LoadRuleGeoRegions = new ReduxAsyncAction('JOURNEYS_LOAD_RULE_GEO_REGIONS');
LoadRuleGeoRegions.registerRequest((partialRegions) => {
  return dash_api.post('/v1/audience-rule/regions/expand', { regions: partialRegions }).then(R.prop('data'));
});
export const LOAD_RULE_GEO_REGIONS = LoadRuleGeoRegions.constants;
export const loadRuleGeoRegions = LoadRuleGeoRegions.request;
